function sendGAEvent(eventName, eventParams) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
}

export { sendGAEvent as default };
//# sourceMappingURL=sendGAEvent.js.map
